export const layoutToWalls = (shape, dimensions) => {

    const wallThickness = 20
    const start = {x: wallThickness, z: wallThickness}
    const a = parseInt(dimensions.a)
    const b = parseInt(dimensions.b)
    const c = parseInt(dimensions.c)
    const d = parseInt(dimensions.d)

    if (shape === "rectangle") {

        const p1 = {x: start.x, z: start.z}
        const p2 = {x: start.x, z: start.z + b}
        const p3 = {x: start.x + a, z: start.z +b}
        const p4 = {x: start.x + a, z: start.z}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z - wallThickness},
                p4: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                p4: {x: p4.x + wallThickness, z: p4.z - wallThickness},
                h: dimensions.height
            },
        ]
    }

    if (shape === "open") {

        const startZ = c >= b ? 0 : (b - c)
        const p1 = {x: start.x, z: startZ}
        const p2 = {x: start.x, z: p1.z + c}
        const p3 = {x: start.x + a, z: p2.z}
        const p4 = {x: start.x + a, z: p3.z - b}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z},
                p4: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                h: dimensions.height
            },
        ]
    }

    if (shape === "l_form_a") {

        const p1 = {x: start.x, z: start.z}
        const p2 = {x: start.x, z: start.z + d}
        const p3 = {x: start.x + a, z: start.z + d}
        const p4 = {x: start.x + a, z: start.z + b}
        const p5 = {x: start.x + c, z: start.z + b}
        const p6 = {x: start.x + c, z: start.z}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z + wallThickness},
                p4: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p5,
                p3: {x: p5.x + wallThickness, z: p5.z + wallThickness},
                p4: {x: p4.x + wallThickness, z: p4.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p5,
                p2: p6,
                p3: {x: p6.x + wallThickness, z: p6.z - wallThickness},
                p4: {x: p5.x + wallThickness, z: p5.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p6,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                p4: {x: p6.x + wallThickness, z: p6.z - wallThickness},
                h: dimensions.height
            }
        ]
    }

    if (shape === "l_form_b") {

        const p1 = {x: start.x, z: start.z}
        const p2 = {x: start.x, z: start.z + d}
        const p3 = {x: start.x + (c - a), z: start.z + d}
        const p4 = {x: start.x + (c - a), z: start.z + b}
        const p5 = {x: start.x + c, z: start.z + b}
        const p6 = {x: start.x + c, z: start.z}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x - wallThickness, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x - wallThickness, z: p4.z + wallThickness},
                p4: {x: p3.x - wallThickness, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p5,
                p3: {x: p5.x + wallThickness, z: p5.z + wallThickness},
                p4: {x: p4.x - wallThickness, z: p4.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p5,
                p2: p6,
                p3: {x: p6.x + wallThickness, z: p6.z - wallThickness},
                p4: {x: p5.x + wallThickness, z: p5.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p6,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                p4: {x: p6.x + wallThickness, z: p6.z - wallThickness},
                h: dimensions.height
            }
        ]
    }

    if (shape === "l_form_c") {

        const p1 = {x: start.x, z: start.z}
        const p2 = {x: start.x, z: start.z + d}
        const p3 = {x: start.x + a, z: start.z + d}
        const p4 = {x: start.x + a, z: start.z + (d - b)}
        const p5 = {x: start.x + c, z: start.z + (d - b)}
        const p6 = {x: start.x + c, z: start.z}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z - wallThickness},
                p4: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p5,
                p3: {x: p5.x + wallThickness, z: p5.z - wallThickness},
                p4: {x: p4.x + wallThickness, z: p4.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p5,
                p2: p6,
                p3: {x: p6.x + wallThickness, z: p6.z - wallThickness},
                p4: {x: p5.x + wallThickness, z: p5.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p6,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                p4: {x: p6.x + wallThickness, z: p6.z - wallThickness},
                h: dimensions.height
            }
        ]
    }

    if (shape === "l_form_d") {

        const p1 = {x: start.x, z: start.z + (b - d)}
        const p2 = {x: start.x, z: start.z + b}
        const p3 = {x: start.x + a, z: start.z + b}
        const p4 = {x: start.x + a, z: start.z}
        const p5 = {x: start.x + (a - c), z: start.z}
        const p6 = {x: start.x + (a - c), z: start.z + (b - d)}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z - wallThickness},
                p4: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p5,
                p3: {x: p5.x - wallThickness, z: p5.z - wallThickness},
                p4: {x: p4.x + wallThickness, z: p4.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p5,
                p2: p6,
                p3: {x: p6.x - wallThickness, z: p6.z - wallThickness},
                p4: {x: p5.x - wallThickness, z: p5.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p6,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                p4: {x: p6.x - wallThickness, z: p6.z - wallThickness},
                h: dimensions.height
            }
        ]
    }

    if (shape === "pentagonal_a") {

        const c1 = wallThickness * a / c
        const c2 = wallThickness * b / d
        const p1 = {x: start.x, z: start.z}
        const p2 = {x: start.x, z: start.z + d}
        const p3 = {x: start.x + a, z: start.z + d}
        const p4 = {x: start.x + c, z: start.z + b}
        const p5 = {x: start.x + c, z: start.z}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x + c1, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z + c2},
                p4: {x: p3.x + c1, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p5,
                p3: {x: p5.x + wallThickness, z: p5.z - wallThickness},
                p4: {x: p4.x + wallThickness, z: p4.z + c2},
                h: dimensions.height
            },
            {
                p1: p5,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                p4: {x: p5.x + wallThickness, z: p5.z - wallThickness},
                h: dimensions.height
            }
        ]
    }

    if (shape === "pentagonal_b") {

        const c1 = wallThickness * a / c
        const c2 = wallThickness * d / b

        const p1 = {x: start.x, z: start.z}
        const p2 = {x: start.x, z: start.z + d}
        const p3 = {x: start.x + (c - a), z: start.z + b}
        const p4 = {x: start.x + c, z: start.z + b}
        const p5 = {x: start.x + c, z: start.z}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + c2},
                p4: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x - c1, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + c2},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z + wallThickness},
                p4: {x: p3.x - c1, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p5,
                p3: {x: p5.x + wallThickness, z: p5.z - wallThickness},
                p4: {x: p4.x + wallThickness, z: p4.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p5,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                p4: {x: p5.x + wallThickness, z: p5.z - wallThickness},
                h: dimensions.height
            }
        ]
    }

    if (shape === "pentagonal_c") {

        const c1 = wallThickness * c / a
        const c2 = wallThickness * b / d

        const p1 = {x: start.x, z: start.z}
        const p2 = {x: start.x, z: start.z + d}
        const p3 = {x: start.x + a, z: start.z + d}
        const p4 = {x: start.x + a, z: start.z + (d - b)}
        const p5 = {x: start.x + c, z: start.z}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z - c2},
                p4: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p5,
                p3: {x: p5.x + c1, z: p5.z - wallThickness},
                p4: {x: p4.x + wallThickness, z: p4.z - c2},
                h: dimensions.height
            },
            {
                p1: p5,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - wallThickness},
                p4: {x: p5.x + c1, z: p5.z - wallThickness},
                h: dimensions.height
            }
        ]
    }

    if (shape === "pentagonal_d") {

        const c1 = wallThickness * c / a
        const c2 = wallThickness * d / b
        const p1 = {x: start.x, z: start.z + (b - d)}
        const p2 = {x: start.x, z: start.z + b}
        const p3 = {x: start.x + a, z: start.z + b}
        const p4 = {x: start.x + a, z: start.z}
        const p5 = {x: start.x + (a - c), z: start.z}

        return [
            {
                p1: p1,
                p2: p2,
                p3: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                p4: {x: p1.x - wallThickness, z: p1.z - c2},
                h: dimensions.height
            },
            {
                p1: p2,
                p2: p3,
                p3: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                p4: {x: p2.x - wallThickness, z: p2.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p3,
                p2: p4,
                p3: {x: p4.x + wallThickness, z: p4.z - wallThickness},
                p4: {x: p3.x + wallThickness, z: p3.z + wallThickness},
                h: dimensions.height
            },
            {
                p1: p4,
                p2: p5,
                p3: {x: p5.x - c1, z: p5.z - wallThickness},
                p4: {x: p4.x + wallThickness, z: p4.z - wallThickness},
                h: dimensions.height
            },
            {
                p1: p5,
                p2: p1,
                p3: {x: p1.x - wallThickness, z: p1.z - c2},
                p4: {x: p5.x - c1, z: p5.z - wallThickness},
                h: dimensions.height
            }
        ]
    }
}
